import { render, staticRenderFns } from "./expenses.vue?vue&type=template&id=76cb4d58"
import script from "./expenses.vue?vue&type=script&lang=js"
export * from "./expenses.vue?vue&type=script&lang=js"
import style0 from "./expenses.vue?vue&type=style&index=0&id=76cb4d58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports